import { memo, useMemo } from "react";
import { Chart } from "primereact/chart";
import { formatearMoneda } from "../../config/moneda";
import { AGRUPACIONES_RANKING } from "../../servicios/ventasReportesUtils";
import ExportarReporte from "../ExportarReporte/ExportarReporte";

const PALETA_VERDE = {
  barra: "#5f9578",
  barraHover: "#477c63",
  texto: "#315b49",
  textoSuave: "#687870",
  borde: "#c8ddd0",
  grilla: "#e3ece6",
};

const abreviar = (texto, maximo = 22) => texto.length > maximo ? `${texto.slice(0, maximo - 1)}…` : texto;

const VentasRankingChart = ({ ranking, agruparPor, onAgrupar, disabled, filters }) => {
  const nombresCompletos = useMemo(() => ranking.map((item) => item.nombre), [ranking]);
  const data = useMemo(() => ({
    labels: nombresCompletos.map((nombre) => abreviar(nombre)),
    datasets: [{
      label: "Venta neta",
      data: ranking.map((item) => item.venta),
      backgroundColor: PALETA_VERDE.barra,
      hoverBackgroundColor: PALETA_VERDE.barraHover,
      borderRadius: 7,
      borderSkipped: false,
      maxBarThickness: 24,
    }],
  }), [nombresCompletos, ranking]);

  const options = useMemo(() => ({
    indexAxis: "y",
    responsive: true,
    maintainAspectRatio: false,
    animation: { duration: 250 },
    interaction: { mode: "index", intersect: false },
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: "#ffffff",
        titleColor: PALETA_VERDE.textoSuave,
        bodyColor: PALETA_VERDE.texto,
        borderColor: PALETA_VERDE.borde,
        borderWidth: 1,
        padding: 10,
        callbacks: {
          title: (items) => nombresCompletos[items[0]?.dataIndex] || "",
          label: (context) => `Venta neta: ${formatearMoneda(context.raw)}`,
        },
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        border: { display: false },
        grid: { color: PALETA_VERDE.grilla },
        ticks: {
          color: PALETA_VERDE.textoSuave,
          callback: (valor) => Number(valor).toLocaleString("es-AR", { notation: "compact", maximumFractionDigits: 1 }),
        },
      },
      y: {
        border: { display: false },
        grid: { display: false },
        ticks: { color: PALETA_VERDE.texto, autoSkip: false, font: { size: 13, weight: "600" } },
      },
    },
  }), [nombresCompletos]);

  return (
    <section className="ventas-panel" aria-labelledby="ventas-ranking-titulo">
      <div className="ventas-panel-titulo">
        <div><h3 id="ventas-ranking-titulo">Ventas por {agruparPor.toLowerCase()}</h3><p>Principales generadores de venta neta</p></div>
        <div className="ventas-panel-acciones">
          <label className="ventas-agrupacion">Agrupar por
            <select disabled={disabled} value={agruparPor} onChange={(e) => onAgrupar(e.target.value)}>
              {AGRUPACIONES_RANKING.map((opcion) => <option key={opcion}>{opcion}</option>)}
            </select>
          </label>
          <ExportarReporte endpoint="PISeunReportes/VentasRanking" filters={filters} nombre="Ranking de ventas" ranking disabled={disabled} />
        </div>
      </div>
      {ranking.length ? (
        <div className="ventas-chart" role="img" aria-label={`Ranking de venta neta por ${agruparPor}`} style={{ height: `${Math.max(250, ranking.length * 40)}px` }}>
          <Chart type="bar" data={data} options={options} />
        </div>
      ) : <p className="sin-datos">No hay datos de ranking para los filtros seleccionados.</p>}
    </section>
  );
};

export default memo(VentasRankingChart);
